class SageUtils {
  static getFilterMapping(key) {
    const mapping = {
      'object_id': 'objectID',
      'not_selected': 'notSelected',
      'root_id': 'rootID',
      'external_id': 'externalID',
      'group_path': 'groupPath',
      'license_id': 'licenseID',
      'license_status': 'licenseStatus',
      'roster_job_id': 'rosterJobID',
      'class_assigned': 'classAssigned',
      'aofl_product': 'product',
    };
    return mapping[key] || key;
  }
}

export {
  SageUtils
};
